export default theme => ({
  root: {
    position: 'fixed',
    left: 0,
    right: 0,
    zIndex: theme.zIndex.tooltip + 1,
  }
});



// WEBPACK FOOTER //
// ./src/components/AppProgress/Indicator/styles.js